import { render, staticRenderFns } from "./FacebookDataDeletion.vue?vue&type=template&id=0b564c58&"
import script from "./FacebookDataDeletion.vue?vue&type=script&lang=js&"
export * from "./FacebookDataDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports